import { combineEpics, ofType } from "redux-observable";
import { catchError, endWith, from, map, of, startWith, switchMap, withLatestFrom } from "rxjs";
import { GetMyDocumentProjects, GetOtherDocumentProjects } from "../../services/documents/documents.service";
import { setLoading, setMyAcknowledgeProjects, setMyArchivedProjects, setOtherAcknowledgeProjects, setOtherArchivedProjects } from "../../store/documents/DocumentsSlice";

const GetMyAcknowledgeProjects = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("documents/getmyAcknowledgeProjects"),
        withLatestFrom(state$),
        switchMap(([actionData, state]) => {
            const payload = {
                ...actionData?.payload,
                type: "Acknowldged"
            }
            return from(GetMyDocumentProjects(payload)).pipe(
                map((response) => {
                    if (response) {
                        return setMyAcknowledgeProjects(response);
                    } else {
                        return setMyAcknowledgeProjects({
                            projects: [],
                            projectsCount: 0
                        });
                    }

                }),
                catchError((error) => {
                    return of(console.error(error));
                }),
                startWith(setLoading(true)),
                endWith(setLoading(false))
            );
        })
    );
};

const GetOtherAcknowledgeProjects = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("documents/getOtherAcknowledgeProjects"),
        withLatestFrom(state$),
        switchMap(([actionData, state]) => {
            const payload = {
                ...actionData?.payload,
                type: "Acknowldged"
            }
            return from(GetOtherDocumentProjects(payload)).pipe(
                map((response) => {
                    if (response) {
                        return setOtherAcknowledgeProjects(response);
                    } else {
                        return setOtherAcknowledgeProjects({
                            projects: [],
                            projectsCount: 0
                        });
                    }

                }),
                catchError((error) => {
                    return of(console.error(error));
                }),
                startWith(setLoading(true)),
                endWith(setLoading(false))
            );
        })
    );
};

const GetMyArchivedProjects = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("documents/getmyArchivedProjects"),
        withLatestFrom(state$),
        switchMap(([actionData, state]) => {
            const payload = {
                ...actionData?.payload,
                type: "Archived"
            }
            return from(GetMyDocumentProjects(payload)).pipe(
                map((response) => {
                    if (response) {
                        return setMyArchivedProjects(response);
                    } else {
                        return setMyArchivedProjects({
                            projects: [],
                            projectsCount: 0
                        });
                    }
                }),
                catchError((error) => {
                    return of(console.error(error));
                }),
                startWith(setLoading(true)),
                endWith(setLoading(false))
            );
        })
    );
};

const GetOtherArchivedProjects = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("documents/getOtherArchivedProjects"),
        withLatestFrom(state$),
        switchMap(([actionData, state]) => {
            const payload = {
                ...actionData?.payload,
                type: "Archived"
            }
            return from(GetOtherDocumentProjects(payload)).pipe(
                map((response) => {
                    if (response) {
                        return setOtherArchivedProjects(response);
                    } else {
                        return setOtherArchivedProjects({
                            projects: [],
                            projectsCount: 0
                        });
                    }
                }),
                catchError((error) => {
                    return of(console.error(error));
                }),
                startWith(setLoading(true)),
                endWith(setLoading(false))
            );
        })
    );
};

export const documentsEpic = combineEpics(
    GetMyAcknowledgeProjects,
    GetMyArchivedProjects,
    GetOtherAcknowledgeProjects,
    GetOtherArchivedProjects
);